'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewList = function ActionViewList(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
  );
};
ActionViewList = (0, _pure2.default)(ActionViewList);
ActionViewList.displayName = 'ActionViewList';
ActionViewList.muiName = 'SvgIcon';

exports.default = ActionViewList;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/view-list.js
 ** module id = 1625
 ** module chunks = 0
 **/